module.exports = __webpack_public_path__ + "img/instagram-icon.241e984a.svg";